export const MENU_OPTIONS = [
  // sign out
  { label: 'Sign out', value: 'sign-out', lang: 'system.signout' },
];
